module.exports = __webpack_public_path__ + "img/output_3.708ce0c0.png";